<template>
  <div class="bottom-bar">
    <div>
      <md-button
        class="vrp-pill-button help-button"
        @click="showHelp"
      >
        <md-icon>help</md-icon>
        Help
      </md-button>
    </div>

    <md-button
      v-if="canCreate"
      class="vrp-pill-button new-button"
      icon="plus"
      type="primary"
      size="large"
      @click="newAssignment"
    >
      CREATE NEW
    </md-button>
  </div>
</template>

<script>
export default {
  name: 'bottom-bar',
  components: {
  },
  props: {
    canCreate: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
  },
  methods: {
    newAssignment() {
      this.$emit('newAssignment');
    },
    showHelp() {
      window.open('https://vrpatients.atlassian.net/wiki/spaces/VP/overview', '_blank');
    }
  },
};
</script>

<style scoped>
.bottom-bar {
  background-color: #303243 !important;
  height: 65px;
  width: 100%;
  display: flex;
  align-items: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
}

.help-button {
  margin-left: 8px !important;
}

.help-button .md-icon {
  color: white;
}

.new-button {
  width: 120px;
  background-color: #62cd63;
  text-transform: capitalize;
}
</style>

